<template>
    <div class="dashboard">
        <h1>Client Dashboard</h1>
        <b-card footer-class="p-0">
            <b-card-group deck>
                <b-card no-body class="border-0">
                    <total-active-clients />
                </b-card>
                <b-card no-body class="border-0">
                    <new-clients />
                </b-card>
                <b-card no-body class="border-0">
                    <total-appointment />
                </b-card>
            </b-card-group>
            <template v-slot:footer>
                <b-tabs card class="list" content-class="dashboard-list">
                    <b-tab active title-link-class="p-0">
                        <template v-slot:title>
                            <b-nav-item-dropdown>
                                <template slot="button-content">
                                    <i class="cus-report-user"></i>
                                    Client List
                                </template>
                                <b-dropdown-item
                                    href="#0"
                                    @click.prevent="filterClientList(0)"
                                >
                                    <i class="cus-report-user"></i>
                                    View All Clients ({{ count.all }})
                                </b-dropdown-item>
                                <b-dropdown-item
                                    href="#0"
                                    @click.prevent="filterClientList(1)"
                                >
                                    <i class="cus-accept"></i>
                                    View Active Clients ({{ count.active }})
                                </b-dropdown-item>
                                <b-dropdown-item
                                    href="#0"
                                    @click.prevent="filterClientList(2)"
                                >
                                    <i class="cus-cross"></i>
                                    View Inactive Clients ({{ count.inactive }})
                                </b-dropdown-item>
                            </b-nav-item-dropdown>
                        </template>
                        <clientList />
                    </b-tab>
                </b-tabs>
            </template>
        </b-card>
    </div>
</template>
<script>
import "@/jquery/jquery.flot";
import newClients from "../report/module/client/new_clients";
import totalActiveClients from "../report/module/client/total_active_clients";
import totalAppointment from "../report/module/client/total_appointments";
import ClientList from "./list";

export default {
    components: {
        newClients,
        totalActiveClients,
        totalAppointment,
        ClientList
    },
    data() {
        return {
            resources: {},
            count: {
                all: 0,
                active: 0,
                inactive: 0
            }
        };
    },
    computed: {},
    created() {},
    mounted() {
        this.getClientCount();
    },
    methods: {
        getClientCount() {
            return this.$http
                .get(process.env.BARRACUDA + "actor/client-count")
                .then(response => {
                    if (response.status === 200) {
                        this.count.all = response.data.response.resource.all;
                        this.count.active =
                            response.data.response.resource.active;
                        this.count.inactive =
                            response.data.response.resource.inactive;
                    }
                });
        },
        filterClientList(status) {
            this.$root.$emit("filter-client-dashboard-list:refresh", {
                status: status
            });
        }
    }
};
</script>
